import JsFileDownloader from 'js-file-downloader';

export default {
  methods: {
    getApiClientHeaders(requestMethod = null) {
      const headers = {};

      const commonHeaders = this.$apiClient.http?.defaults?.headers?.common || {};
      const commonHeaderNames = commonHeaders ? Object.keys(commonHeaders) : [];

      for (const headerName of commonHeaderNames) {
        headers[headerName] = commonHeaders[headerName];
      }

      if (requestMethod) {
        const requestMethodHeaders = this.$apiClient.http?.defaults?.headers[requestMethod] || {};
        const requestMethodHeaderNames = requestMethodHeaders ? Object.keys(requestMethodHeaders) : [];

        for (const headerName of requestMethodHeaderNames) {
          headers[headerName] = requestMethodHeaderNames[headerName];
        }
      }

      return headers;
    },
    getHtmlFromBody() {
      let realHTML = document.getElementsByTagName('html')[0].outerHTML;

      // Make sure that scripts don't load.
      realHTML = realHTML.replace(/<script/ig, '<script-no-load style="display: none;"');
      realHTML = realHTML.replace(/<\/\s*script/ig, '</script-no-load');

      /*
      // NOTE: This doesn't work right because when copying in the <html> tags inside the div element it removes them, so you don't actually end up with the real outer HTML
      const div = document.createElement('div');

      div.innerHTML = realHTML;

      div.querySelectorAll('script').forEach((scriptTag) => {
        scriptTag.parentNode.removeChild(scriptTag);
      });

      return div.innerHTML;
      */

      return realHTML;
    },
    downloadHtmlFromBody(filename = 'body.html') {
      return new Promise((resolve) => {
        const html = this.getHtmlFromBody();

        const data = new Blob([html], { type: 'text/html; charset=utf-8' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(data);
        a.download = filename;
        a.click();

        resolve(a);
      });
    },
    downloadPdfFromBody(filename = 'report.pdf', html = null) {
      if (!html) {
        html = this.getHtmlFromBody();
      }

      const headers = this.getApiClientHeaders();
      const headerNames = Object.keys(headers);
      const requestHeaders = [];

      for (const headerName of headerNames) {
        requestHeaders.push({
          name: headerName,
          value: headers[headerName],
        });
      }

      const jsFileDownloaderConfig = {
        method: 'POST',
        url: this.$apiClient.getFullUrl('/pdf/generate-from-html'),
        body: html,
        headers: requestHeaders,
        autoStart: false,
        withCredentials: true,
        contentType: 'text/html',
        timeout: 60000,
        nameCallback(name) {
          return filename;
        },
        forceDesktopMode: true, // Without this it doesn't work right on android or IOS
      };

      const jsFileDownloader = new JsFileDownloader(jsFileDownloaderConfig);

      return jsFileDownloader.start();
    },
  },
};
